var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6663 8.59992V11.3999C10.6663 13.7333 9.73301 14.6666 7.39967 14.6666H4.59967C2.26634 14.6666 1.33301 13.7333 1.33301 11.3999V8.59992C1.33301 6.26659 2.26634 5.33325 4.59967 5.33325H7.39967C9.73301 5.33325 10.6663 6.26659 10.6663 8.59992Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3989 1.33325H8.59887C6.67817 1.33325 5.71054 1.97018 5.4281 3.49252C5.32651 4.04009 5.79386 4.49992 6.35077 4.49992H7.39887C10.1989 4.49992 11.4989 5.79992 11.4989 8.59992V9.64802C11.4989 10.2049 11.9587 10.6723 12.5063 10.5707C14.0286 10.2882 14.6655 9.32062 14.6655 7.39992V4.59992C14.6655 2.26659 13.7322 1.33325 11.3989 1.33325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyWhite);
export default __webpack_public_path__ + "static/media/copy-white.5a8e62d4739b207c8700ef9fc1670760.svg";
export { ForwardRef as ReactComponent };